import { Submitted as PoaSubmitted } from './submitted';

export default PoaSubmitted;
